import React, { useEffect, useState } from 'react'
import { getGoodTypesAllAPI } from '../../../api/products/goodTypeAPI'
import MySelect from '../../UI/form/MySelect'
import { responseError } from '../../../helpers/response/ResponseHelper'
import { getContractsAllAPI } from '../../../api/contract/contractAPI'

const ContractSelectMain = ({ required, setValidate, setValueForm, forciblyValue }) => {

  	const [value, setValue] = useState(forciblyValue)
	const [contracts, setContracts] = useState([])

	useEffect(() => {
		getGoodTypes()
	}, [])

	useEffect(() => {
		valid()
	}, [required, value])

	const getGoodTypes = () => {
		getContractsAllAPI().then(data => {
			setContracts(data)
		}).catch(e => {
			// setError(responseError(e))
			console.error(responseError(e))
		})
	}

	const valid = () => {
		if (required) {
			if (value) {
				setValidate(true)
			} else {
				setValidate(false)
			}
		} else {
			setValidate(true)
		}
	}

  return (
    <MySelect
        value={value}
        label="Контракт"
        labelId="select__contract-label"
        id='select__contract'
        onChange = {e => {
			setValueForm(e)
            setValue(e)
			// setEvent({...event, categoryId: e})
		}}
        nameField='Контракт'
        // sx={{width: '200px'}}
        options={
			contracts && contracts.length > 0 ? 
				contracts.map(contract => {
            		return {id: contract.id, name: contract.name}
				})
			: []	
		}
        // options={[]}
    />
  )
}

export default ContractSelectMain